import DOMPurify from 'dompurify'

export const sanitizeHtml = (str: string) => {
  return DOMPurify.sanitize(str, {
    ADD_ATTR: ['target'],
  })
}
